import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Instagram } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    items,
    openCart
  } = useCartStore();
  const cartItemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
  return <header className="fixed top-0 left-0 right-0 z-40 bg-brand-bg/90 backdrop-blur-xl border-b border-brand-primary/10 transition-all duration-300" data-id="element-32" data-mp="2ni7kvo10jzo2">
      <div className="max-w-7xl mx-auto px-6 py-5 flex justify-between items-center" data-id="element-33" data-mp="2wk73ulvl9dtn">
        <Link to="/" className="text-xl font-serif font-medium tracking-tight flex items-center hover:opacity-70 transition-opacity duration-200 text-brand-primary" data-id="element-34" data-mp="31bp2v4e1x4bz">
          MyPlaner<span className="text-brand-accent" data-id="element-35" data-mp="3bb66lg9qt85b">.</span>
        </Link>

        <div className="flex items-center gap-8" data-id="element-36" data-mp="3fbgnvp2zjkzh">
          <a href="https://www.instagram.com/myplaner.ua/p/DXq4XE3jJA8/" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 text-brand-muted hover:text-brand-primary transition-colors duration-200 text-xs uppercase tracking-[0.15em] font-medium" data-id="element-37" data-mp="3fc9khx88cu3w">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-38" data-mp="2hnljr446gsz9" />
            <span data-id="element-39" data-mp="2hpep8g32175o">@myplaner.ua</span>
          </a>

          <button onClick={openCart} aria-label="Кошик" className="relative flex items-center justify-center w-9 h-9 text-brand-primary hover:opacity-60 transition-opacity duration-200" data-id="element-40" data-mp="3fbvldi01xepu">
            <ShoppingCart className="w-[19px] h-[19px]" strokeWidth={1.5} data-id="element-41" data-mp="35k7x1pyskdsl" />
            <AnimatePresence data-id="element-42" data-mp="30n7sjjhlbj3l">
              {cartItemsCount > 0 && <motion.span initial={{
              scale: 0,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} exit={{
              scale: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="absolute -top-0.5 -right-0.5 bg-brand-primary text-white text-[9px] font-medium w-[16px] h-[16px] flex items-center justify-center rounded-full" data-id="element-43" data-mp="1wftkz9gcx2m">
                  {cartItemsCount}
                </motion.span>}
            </AnimatePresence>
          </button>
        </div>
      </div>
    </header>;
}